import { render, staticRenderFns } from "./HdsTab.vue?vue&type=template&id=36cd1b64"
import script from "./HdsTab.vue?vue&type=script&lang=ts"
export * from "./HdsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports